import { abyssColors } from '@/theme/colors';
import styled from 'styled-components';

export const AlarmLevelContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 40px;
  text-align: center;
  color: ${abyssColors.error[600]};
`;
